import React, {ReactNode} from 'react';
import {Link} from "react-router-dom";
import {ReactComponent as ArrowRightSVG} from "../../../../../images/icons/arrow-right.svg";
import RoundedIcon from "../../../../components/Common/RoundedIcon";

interface Props {
    link?: string;
    icon: JSX.Element;
    loading?: boolean;
    title: string;
    description: string | JSX.Element;
    onClick?: () => void | Promise<void>;
    primaryBackground?: boolean;
}

const HomepageMenusItem = ({link, icon, loading, title, description, onClick, primaryBackground}: Props) => {
    const drawWrapper = (children: ReactNode) => {
        if (link) {
            return (
                <Link to={link}
                      className={`nav-link nav-link-homepage ${primaryBackground ? "background-primary" : ""}`}>
                    {children}
                </Link>
            )
        }

        return (
            <button onClick={onClick} className="nav-link nav-link-homepage">
                {children}
            </button>
        )
    }

    return drawWrapper(
        <>
            <RoundedIcon icon={icon} size="medium" color="primary"/>
            <div>
                <h1 className="home-page-small-heading">
                    {title}
                </h1>
                <p>
                    {description}
                </p>
            </div>
            {
                loading ? <span className="left spinner-border spinner-border-sm"/> : <ArrowRightSVG/>
            }
        </>
    )
}

export default HomepageMenusItem;